import { Model } from "survey-react-ui";
import { ConfigProvider } from "antd";
import {
  registerContext,
  registerDefaults,
  registerEventHandlers,
  registerSurveyExtensions,
  SurveyForm,
} from "@rumbledirect/survey";
import "survey-core/i18n/dutch";
import { AxiosInstance } from "axios";
import { useMemo } from "react";

registerSurveyExtensions();

export const FormRenderer = ({
  schema,
  api,
  context,
}: {
  schema: any;
  api: AxiosInstance;
  context: any;
}) => {
  const STORAGE_ITEM_DATA_KEY = `dealer-intake-v2-${schema.etag}-data`;
  const STORAGE_ITEM_UI_STATE_KEY = `dealer-intake-v2-${schema.etag}-state`;

  const survey = useMemo(() => {
    const model = new Model();

    registerDefaults(model, api);
    model.fromJSON(schema.formConfiguration);
    const savedData = (() => {
      const raw = window.localStorage.getItem(STORAGE_ITEM_DATA_KEY);
      if (!raw) return {};
      try {
        return JSON.parse(raw) as Record<string, unknown>;
      } catch {
        return {};
      }
    })();

    model.startLoadingFromJson();
    model.mergeData(savedData);
    registerContext(model, api, context);
    model.endLoadingFromJson();
    registerEventHandlers(model, api, "dealer-intake", {
      dataStorageKey: STORAGE_ITEM_DATA_KEY,
      uiStateStorageKey: STORAGE_ITEM_UI_STATE_KEY,
    });

    return model;
  }, [schema, api, context, STORAGE_ITEM_DATA_KEY, STORAGE_ITEM_UI_STATE_KEY]);

  return (
    <ConfigProvider>
      <SurveyForm model={survey} />
    </ConfigProvider>
  );
};
